import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import ChevronIcon from '../../assets/svgs/ChevronIcon';

import onlyNumbers from '../../utils/onlyNumbers';

import { PerformanceImageGalleryStyle } from './PerformanceImageGalleryStyle';

const PerformanceImageGallery = ({ images }) => {
  const [step, setStep] = useState(1);

  const imageLength = useMemo(() => {
    if (images && images.length) {
      return images.length;
    }

    return 0;
  }, [images]);

  const onChangeInputRange = (event) => {
    if (
      event &&
      event.target &&
      event.target.value &&
      event.target.value.length
    ) {
      let currentStep = onlyNumbers(event.target.value);
      if (currentStep && currentStep.length) {
        currentStep = parseInt(currentStep, 10);
        setStep(currentStep);
      }
    }
  };

  const onClickImageGalleryNavigation = (newStep) => {
    let currentStep = newStep;

    if (currentStep <= 1) {
      currentStep = 1;
    }

    if (currentStep >= imageLength) {
      currentStep = imageLength;
    }

    setStep(currentStep);
  };

  return (
    <PerformanceImageGalleryStyle>
      <div className="input-range-container">
        <input
          className="input-range-element"
          type="range"
          value={step}
          min={1}
          max={imageLength}
          step={1}
          onChange={onChangeInputRange}
        />
        <p className="input-range-label">slice</p>
        <p className="input-range-value">{step}</p>
      </div>
      <div className="exam-images-container">
        {images?.length
          ? images?.map((image, index) => (
              <div
                key={image?.id}
                className={`single-exam-image${
                  index === step - 1 ? ' show' : ''
                }`}
              >
                <div className="exam-image-wrapper">
                  {image?.original?.length ? (
                    <img
                      className="exam-image-file"
                      src={image?.original}
                      alt="Original"
                    />
                  ) : null}
                </div>
                <div className="exam-image-wrapper">
                  {image?.classificated?.length ? (
                    <img
                      className="exam-image-file"
                      src={image?.classificated}
                      alt="Classificated"
                    />
                  ) : null}
                  {image?.mask?.length ? (
                    <img
                      className="exam-image-file exam-image-mask"
                      src={image?.mask}
                      alt="Mask"
                    />
                  ) : null}
                </div>
              </div>
            ))
          : null}
      </div>
      <button
        className="image-gallery-navigation-previous"
        type="button"
        disabled={step <= 1}
        onClick={() => onClickImageGalleryNavigation(step - 1)}
      >
        <ChevronIcon />
      </button>
      <button
        className="image-gallery-navigation-next"
        type="button"
        disabled={step >= imageLength}
        onClick={() => onClickImageGalleryNavigation(step + 1)}
      >
        <ChevronIcon />
      </button>
    </PerformanceImageGalleryStyle>
  );
};

PerformanceImageGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      original: PropTypes.string,
      classificated: PropTypes.string,
      mask: PropTypes.string,
    })
  ),
};

PerformanceImageGallery.defaultProps = {
  images: [],
};

export default PerformanceImageGallery;
